import assign from 'lodash/assign';
import modal from '~/redux/reducers/modal';
import common from '~/redux/reducers/common';
import address from '~/redux/reducers/address';
import billing from '~/redux/reducers/billing';
import contactCredit from '~/redux/reducers/contact-credit';
import products from '~/redux/reducers/products';
import appointment from '../reducers/appointment';
import debug from '~/redux/reducers/debug';
import quiz from '~/redux/reducers/quiz';
import legal from '~/redux/reducers/legal';
import { Reducers } from '~/types/redux';
import clientSide from '~/helpers/clientSide';
import recommendation from '../reducers/recommendation';
import enrichedCustomer from '../reducers/enrichedCustomer';
import breadcrumbsControl from '../reducers/breadcrumbsControl';
import chatbot from '../reducers/chatbot';
import sessionSummary from '../reducers/sessionSummary';

const combineReducers = (reducers: Reducers) => {
  const reducersList = Object.values(reducers);

  const combination = (state = {}, action) => {
    let nextState = { ...state };

    // Loop through all passed reducers and create new state
    reducersList.forEach((reducer) => {
      const newState = reducer(nextState, action);
      nextState = assign(nextState, newState);
    });

    if (clientSide) {
      window.sessionStorage.setItem('persist:fuel', JSON.stringify(nextState));
    }

    return nextState;
  };

  return combination;
};

const reducers = combineReducers({
  modal,
  common,
  address,
  billing,
  contactCredit,
  products,
  appointment,
  debug,
  quiz,
  legal,
  recommendation,
  enrichedCustomer,
  breadcrumbsControl,
  chatbot,
  sessionSummary,
});

export default reducers;
